<template lang="pug">
.FcwBlogHomeTemplate
  FcwHero(
    v-bind="hero"
    cta-location="#posts"
    mode="blog-home"
  )
  #posts
  FcwSection.FcwBlogHomeTemplate__postsWrapper
    FcwSectionContent
      FGrid(
        gap="24"
        columns="6"
      )
        template(v-if="blogPostCards.length")
          FGridItem(
            v-for="(blogPost, index) in blogPostCards"
            :key="blogPost.slug"
            :span="gridItemPattern[index % gridItemPattern.length]"
            :md="mdGridItemPattern[index % mdGridItemPattern.length]"
            sm="6"
          )
            FcwRouterLink.FcwBlogHomeTemplate__cardWrapper(
              :location="{ name: `showcase-blog-slug`, params: { slug: blogPost.slug } }"
              hide-arrow
            )
              FcwBlogPostCard(v-bind="blogPost")
        FGridItem(
          v-else
          span="6"
        )
          p {{ t('blog__no_article') }}
</template>

<style lang="stylus">
.FcwBlogHomeTemplate__postsWrapper
  margin rem(72) 0

#posts
  scroll-margin-top rem(56)

.FcwBlogHomeTemplate__cardWrapper
  width 100%

  .FLink__content
    width 100%
</style>

<script lang="ts" setup>
import type { FGridItemProps } from '@fifteen/design-system-vue';
import type { FcwBlogPostCardProps } from '@/components/organisms/FcwBlogPostCard.vue';
import type { FcwHeroProps } from '@/components/organisms/FcwHero.vue';

export interface FcwBlogHomeTemplateProps {
  /**
   * Hero props
   */
  hero: FcwHeroProps;
  /**
   * Array of blog post cards
   */
  blogPostCards: FcwBlogPostCardProps[];
}

defineProps<FcwBlogHomeTemplateProps>();

const { t } = useClientI18n();

// Patterns that defines the grid row span
const gridItemPattern: FGridItemProps['span'][] = [
  '2',
  '4',
  '2',
  '2',
  '2',
  '4',
  '2',
];
const mdGridItemPattern: FGridItemProps['span'][] = ['6', '3', '3'];
</script>
